class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
    this.desktopQuery = window.matchMedia('(min-width: 750px)');
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  disconnectedCallback() {
    this.teardownProgress();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        if (!this.isConnected) return;

        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          try {
            recommendations.querySelectorAll('.product-title').forEach(titleEl => {
              if (titleEl.textContent.includes('Sample') || titleEl.textContent.includes('Credit')) {
                const card = titleEl.closest('li');
                if (card) card.remove();
              }
            });
          } catch (filterError) {
            console.error('Sample filter failed, showing unfiltered recommendations:', filterError);
          }

          this.innerHTML = recommendations.innerHTML;
          this.initProgress();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  /* ---------- Progress Bar ---------- */

  initProgress() {
    this.teardownProgress();

    this.scroller = this.querySelector('.mini-cart__navigation');
    if (!this.scroller) return;

    this.progressEl = document.createElement('div');
    this.progressEl.className = 'cart-recommendations__progress';
    this.progressEl.setAttribute('aria-hidden', 'true');
    this.progressEl.innerHTML = '<span class="cart-recommendations__progress-bar"></span>';
    this.scroller.after(this.progressEl);

    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(this.updateProgress);
    this.resizeObserver.observe(this.scroller);
    Array.from(this.scroller.children).forEach(child => this.resizeObserver.observe(child));

    this.desktopQuery.addEventListener('change', this.updateProgress);

    this.scroller.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', this.updateProgress, { once: true });
    });

    this.updateProgress();
  }

  teardownProgress() {
    if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    this.desktopQuery.removeEventListener('change', this.updateProgress);
    if (this.rafId) cancelAnimationFrame(this.rafId);
    if (this.progressEl) this.progressEl.remove();
    this.scroller = null;
    this.resizeObserver = null;
    this.progressEl = null;
    this.rafId = null;
  }

  onScroll() {
    if (this.rafId) return;
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      this.updateProgress();
    });
  }

  updateProgress() {
    const scroller = this.scroller;
    if (!scroller) return;

    // Desktop: vertikale Liste im Seitenpanel, Mobile: horizontaler Slider
    const vertical = this.desktopQuery.matches;
    const position = Math.abs(vertical ? scroller.scrollTop : scroller.scrollLeft); // abs() für RTL
    const visible = vertical ? scroller.clientHeight : scroller.clientWidth;
    const total = vertical ? scroller.scrollHeight : scroller.scrollWidth;
    const remaining = total - visible - position;

    // Füllstand = sichtbarer Anteil + bereits gescrollter Anteil → am Ende exakt 100 %
    let progress = total > 0 ? (position + visible) / total : 1;
    if (remaining <= 1) progress = 1;
    progress = Math.min(Math.max(progress, 0), 1);

    this.style.setProperty('--cart-reco-progress', progress.toFixed(4));
    this.classList.toggle('is-scrollable', total - visible > 1);
  }
}

customElements.define('cart-recommendations', CartRecommendations);